<template>
  <div class="packed-circle-controls">
    <div class="row packed-circle-controls__filters" style="padding-top: 0">
      <div class="col-xs-12 col-12 col-sm-6">
        <select-filter
          v-model="internalCategoryParent"
          :selections="categoryParents"
          :fluid="true"
          :label-icon="true"
          label="View by"
          style="margin: 0px !important"
        />
      </div>
      <template v-if="!$breakpoint.mobile">
        <div class="col-xs-12 col-12 col-sm-6 packed-circle-controls__filters__show-percentage">
          <switch-com
            class="switch"
            input-el-id="packed-circles-switch"
            label="Show percentage"
            v-model="showPercentage"
            @input="$emit('show-percentage', showPercentage)"
          />
        </div>
        <div class="col-sm-12 mt-10 packed-circle-controls__filters__region control-radio">
          <label v-for="cat in categories" :key="cat" class="form-check radio-inline" style="margin-right: 24px">
            <input
              class="form-check-input"
              type="radio"
              name="packed-circle-radio"
              :value="cat"
              :checked="cat === internalCategory"
              @input="updateCategory(cat)"
            />
            <span class="form-check-label"> {{ cat }} </span>
          </label>
        </div>
      </template>
      <template v-else>
        <div class="col-sm-12 packed-circle-controls__filters__region control-radio">
          <label v-for="cat in categories" :key="cat" class="form-check radio-inline" style="margin-right: 24px">
            <input
              class="form-check-input"
              type="radio"
              name="packed-circle-radio"
              :value="cat"
              :checked="cat === internalCategory"
              @input="updateCategory(cat)"
            />
            <span class="form-check-label"> {{ cat }} </span>
          </label>
        </div>
        <div class="col-xs-12 col-12 col-sm-6 packed-circle-controls__filters__show-percentage">
          <switch-com
            class="switch"
            input-el-id="packed-circles-switch"
            label="Show percentage"
            v-model="showPercentage"
            @input="$emit('show-percentage', showPercentage)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SwitchCom from '../../../ui/SwitchCom.vue';
import SelectFilter from '../../../ui/SelectFilter.vue';

export default {
  name: 'PackedCircleControls',
  components: {
    SwitchCom,
    SelectFilter,
  },
  props: {
    categoryParents: Array,
    categoryParent: {
      type: String,
      default: 'Country',
    },
    categories: Array,
    category: {
      type: String,
      default: 'ASEAN-6',
    },
  },
  computed: {
    internalCategoryParent: {
      get() {
        return this.categoryParent;
      },
      set(v) {
        this.$emit('update:categoryParent', v);
      },
    },
    internalCategory: {
      get() {
        return this.category;
      },
      set(v) {
        this.$emit('update:category', v);
      },
    },
  },
  data: () => ({
    showPercentage: false,
  }),
  methods: {
    updateCategory(cat) {
      this.internalCategory = cat;
    },
  },
  mounted() {
    // console.log(this.internalCategory);
  },
};
</script>

<style lang="scss" scoped>
.packed-circle-controls {
  font-size: 16px;

  &__filters {
    &__region {
      color: #005eb8;
    }

    @media #{map-get($media-breakpoints, 'mobile')} {
      &__show-percentage,
      &__region {
        margin-top: 15px;
      }

      &__region {
        margin-left: 8px;
      }
    }
  }
}
.switch {
  /* md and up */
  @media only screen and (min-width: #{map-get($grid-breakpoints, 'sm')}) {
    float: right !important;
  }
}

.control-radio {
  display: flex;
  flex-wrap: wrap;

  input[type='radio'] {
    -webkit-appearance: none;
    width: 14px;
    height: 14px;
    border: 1px solid #005eb8 !important;
    border-radius: 50%;
    margin-left: -20px;
    margin-top: 5px;
  }

  input[type='radio']:before {
    content: '';
    display: block;
    width: 50%;
    height: 50%;
    margin: 25% auto;
    border-radius: 50%;
    border: unset;
  }

  input[type='radio']:checked:before {
    background: #005eb8;
  }

  input.form-check-input {
    margin-left: -20px !important;
    margin-top: 5px !important;
  }
}
.radio-inline {
  margin-left: 0px !important;
}

@media #{map-get($media-breakpoints, 'mobile')} {
  .radio-inline {
    margin-left: 0px !important;
    min-width: 102px; 
  }
}

label.radio-inline .form-check-label {
  color: #005eb8 !important;
  font-size: 16px !important;
}
</style>
